(function() {
    'use strict';

    angular
        .module('app.turnos')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/turnos',
                config: {
                    templateUrl: 'app/turnos/turnos.html',
                    controller: 'Turnos',
                    controllerAs: 'vm',
                    title: 'Turnos'
                }
            },
            {
                url: '/editar-turno/:id?',
                config: {
                    templateUrl: 'app/turnos/editarTurno.html',
                    controller: 'EditarTurno',
                    controllerAs: 'vm',
                    title: 'EditarTurno'
                }
            }
        ];
    }
})();
